import {
    Character,
    DamageNature,
    Effect,
    EffectDuration,
    EffectTriggered,
    Event,
    FullDamage,
    Interrupt,
    TurnEnded,
    Turns,
} from 'game/core'
import { Memoize } from 'game/util/memoize'

export class PoisonedShotEffect extends Effect<{
    damage: FullDamage,
    turns: Turns
}>{
    static KEY = 'PoisonedShotEffect' as const

    @Memoize()
    get duration(): EffectDuration {
        return {
            type: 'turns',
            turns: this.state.turns
        }
    }

    @Memoize()
    get damage(): FullDamage {
        return {
            ...this.state.damage,
            nature: DamageNature.Recurrent
        }
    }

    // ----- State change inquiry ----- //
    reactToEvent(event: Event): Interrupt {
        if (!(event instanceof TurnEnded)) return false
        if (event.character !== this.target) return false

        return this.battle
            .startEvent(EffectTriggered, { effect: this.path })
            .perform(Character, this.target.path, char => char.takeDamage(this.damage))
            .endEvent()
    }
}